import {
    FaReact,
    FaNodeJs,
    FaHtml5,
    FaCss3Alt,
    FaJsSquare,
    FaPython,
    FaDocker,
    FaAws,
    FaGitAlt,
    FaDatabase, FaJava, FaAngular, FaJedi, FaJediOrder, FaAmazon, FaNetworkWired, FaTasks, FaStore
} from 'react-icons/fa';
import {
    SiTypescript,
    SiNextdotjs,
    SiMongodb,
    SiPostgresql,
    SiGraphql,
    SiKubernetes,
    SiRedux,
    SiTailwindcss,
    SiJest,
    SiWebpack,
    SiJenkins,
    SiArgo,
    SiKibana,
    SiNewrelic,
    SiJunit5,
    SiCucumber,
    SiMysql,
    SiSpring,
    SiOracle,
    SiRedis,
    SiRabbitmq,
    SiMessenger,
    SiSonarqube,
    SiTestrail,
    SiSecurityscorecard,
    SiSpringsecurity,
    SiSpringboot,
    SiAwsamplify,
    SiAwselasticloadbalancing, SiAwslambda, SiAwsorganizations
} from 'react-icons/si';
import { GrCluster } from 'react-icons/gr';

const skillsData = [
    {
        category: 'Core Java & Backend',
        technologies: [
            {
                name: 'Java',
                icon: FaJava,
                color: '#3070af'
            },
            {
                name: 'Spring Boot',
                icon: SiSpringboot,
                color: '#3bab37'
            },
            {
                name: 'JEE',
                icon: FaJava,
                color: '#cf8c67'
            },
            {
                name: 'Microservices',
                icon: GrCluster,
                color: '#000000'
            },
            {
                name: 'Python',
                icon: FaPython,
                color: '#e8a150'
            },
            {
                name: 'RESTful APIs',
                icon: FaNetworkWired,
                color: '#8ccae1'
            },
            {
                name: 'Database Development',
                icon: FaDatabase,
                color: '#E34F26'
            }
        ]
    },
    {
        category: 'Full Stack Development',
        technologies: [
            {
                name: 'Angular',
                icon: FaAngular,
                color: '#ad77c3'
            },
            {
                name: 'ReactJS',
                icon: FaReact,
                color: '#7cabc8'
            },
            {
                name: 'HTML5',
                icon: FaHtml5,
                color: '#E34F26'
            },
            {
                name: 'CSS3',
                icon: FaCss3Alt,
                color: '#341485'
            },
            {
                name: 'JavaScript',
                icon: FaJsSquare,
                color: '#F7DF1E'
            },
            {
                name: 'TypeScript',
                icon: SiTypescript,
                color: '#3178C6'
            }
        ]
    },
    {
        category: 'Cloud & Containerization',
        technologies: [
            {
                name: 'AWS',
                icon: FaAws,
                color: '#232F3E'
            },
            {
                name: 'Kubernetes',
                icon: SiKubernetes,
                color: '#326CE5'
            },
            {
                name: 'AWS EKS',
                icon: SiKubernetes,
                color: '#dd8249'
            },{
                name: 'Docker',
                icon: FaDocker,
                color: '#2496ED'
            },
            {
                name: 'AWS Amplify',
                icon: SiAwsamplify,
                color: '#cc2552'
            },
            {
                name: 'AWS EC2 & Elastic LB',
                icon: SiAwselasticloadbalancing,
                color: '#bc8545'
            },
            {
                name: 'AWS Lambda',
                icon: SiAwslambda,
                color: '#bc7324'
            },
            {
                name: 'AWS SES',
                icon: SiAwsorganizations,
                color: '#3d55c3'
            },
            {
                name: 'AWS SQS',
                icon: FaAws,
                color: '#d47bd6'
            },
            {
                name: 'AWS RDS',
                icon: FaDatabase,
                color: '#066eef'
            },
            {
                name: 'AWS S3',
                icon: FaStore,
                color: '#1a6530'
            }
        ]
    },
    {
        category: 'Databases & Messaging',
        technologies: [
            {
                name: 'MySQL',
                icon: SiMysql,
                color: '#4479A1'
            },
            {
                name: 'PostgreSQL',
                icon: SiPostgresql,
                color: '#4479A1'
            },
            {
                name: 'Oracle',
                icon: SiOracle,
                color: '#e33c4f'
            },
            {
                name: 'Redis',
                icon: SiRedis,
                color: '#ed3587'
            },
            {
                name: 'RabbitMQ',
                icon: SiRabbitmq,
                color: '#cf8651'
            },
            {
                name: 'Amazon SQS (Simple Queue Service)',
                icon: FaAmazon,
                color: '#339933'
            },
            {
                name: 'JMS (Java Messaging Service)',
                icon: SiMessenger,
                color: '#dd2b45'
            }
        ]
    },
    {
        category: 'DevOps & Automation',
        technologies: [
            {
                name: 'Gitlab CI',
                icon: FaGitAlt,
                color: '#F05032'
            },
            {
                name: 'ArgoCD',
                icon: SiArgo,
                color: '#e5ac32'
            },
            {
                name: 'Jenkins',
                icon: SiJenkins,
                color: '#2e3c5e'
            },
            {
                name: 'ELK (Elastic, Logstash & Kibana)',
                icon: SiKibana,
                color: '#248542'
            },
            {
                name: 'New Relic',
                icon: SiNewrelic,
                color: '#b3e37f'
            }
        ]
    },
    {
        category: 'Testing, Security & Methodologies',
        technologies: [
            {
                name: 'JUnit',
                icon: SiJunit5,
                color: '#d52367'
            },
            {
                name: 'Mockito',
                icon: SiJunit5,
                color: '#639840'
            },
            {
                name: 'Cucumber',
                icon: SiCucumber,
                color: '#165114'
            },
            {
                name: 'SonarQube',
                icon: SiSonarqube,
                color: '#1e032b'
            },
            {
                name: 'TestRail',
                icon: SiTestrail,
                color: '#b9cc63'
            },
            {
                name: 'OAuth 2.0',
                icon: SiSecurityscorecard,
                color: '#d1653d'
            },
            {
                name: 'JWT',
                icon: SiSecurityscorecard,
                color: '#4a9f29'
            },
            {
                name: 'Spring Security',
                icon: SiSpringsecurity,
                color: '#9dd646'
            },
            {
                name: 'Agile Methodology',
                icon: FaTasks,
                color: '#4479A1'
            }
        ]
    }
];

export default skillsData;